import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Home from "../views/serviceArea.vue"
import Area from "../views/serviceArea2.vue"
// import Reserve from "../views/reserve.vue"
import Reserved from "../views/reserved.vue"
import ReserveShose from "../views/reserveShose.vue"
import ReserveCup from "../views/reserve_Cup.vue"
import ReserveZh from "../views/reserve_Zh.vue"
import ReserveStreet from "../views/reserve_Street.vue"
import ReserveQj from "../views/reserve_Qj.vue"
import Serve from "../views/serveComplete.vue"
import Sign from "../views/sign.vue"
import Accord from "../views/accord.vue"

const routes: Array<RouteRecordRaw> = [
  { // 查看地址页面
    path: "/",
    name: "home",
    component: Home,
    meta: {
      keepAlive: false
    }
  },
  { // 查看家政服务地址页面
    path: "/area",
    name: "area",
    component: Area,
    meta: {
      keepAlive: false
    }
  },
  { // 预约页面
    path: "/u/:su",
    name: "reserveStreet",
    component: ReserveStreet,
    meta: {
      keepAlive: false
    }
  },
  { // 全季Logo预约页面
    path: "/qj/:su",
    name: "reserveQj",
    component: ReserveQj,
    meta: {
      keepAlive: false
    }
  },
  { // 已预约页面
    path: "/reserved/:su",
    name: "reserved",
    component: Reserved,
    meta: {
      keepAlive: false
    }
  },
  { //  鞋靴预约页面
    path: "/shose/:su",
    name: "reserveShose",
    component: ReserveShose,
    meta: {
      keepAlive: false
    }
  },
  { //  招行预约页面
    path: "/zh/:su",
    name: "reserveZh",
    component: ReserveZh,
    meta: {
      keepAlive: false
    }
  },
  // { //  盛京银行预约页面
  //   path: "/street/:su",
  //   name: "ReserveStreet",
  //   component: ReserveStreet,
  //   meta: {
  //     keepAlive: false
  //   }
  // },
  { // 杯子礼品预约页面
    path: "/cup/:su",
    name: "reserveCup",
    component: ReserveCup,
    meta: {
      keepAlive: false
    }
  },
  { // 完成服务页面
    path: "/serve",
    name: "serve",
    component: Serve,
    meta: {
      keepAlive: false
    }
  },
  { // 签名页面
    path: "/sign",
    name: "sign",
    component: Sign,
    meta: {
      keepAlive: false
    }
  },
  { // 保价协议页面
    path: "/accord",
    name: "accord",
    component: Accord,
    meta: {
      keepAlive: false
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
